import { skipToken } from '@tanstack/react-query';
import { ComboBox } from '../../components/comboBox.tsx';
import { NavBar } from '../../components/navBar.tsx';
import { PageTitle } from '../../components/pageTitle.tsx';
import { trpc } from '../../utils/trpc/trpc.ts';
import { ProductInfoForm } from './productInfoForm.tsx';
import { usePartNameInUrl } from './usePartName.ts';


export function ProductPage() {

    const { partName, setPartName } = usePartNameInUrl();

    const { data: partNames } = trpc.products.getPartNames.useQuery(
        undefined,
        { select: (partNames) => [...partNames.sort()] }
    );

    const { data: productInfo } = trpc.products.getProductInfo.useQuery(
        partName ? { partName } : skipToken,
    );

    const { data: isAdmin } = trpc.user.isAdmin.useQuery(undefined, { refetchOnWindowFocus: false });


    const readOnly = !isAdmin;
    return (
        <>
            <PageTitle title='Product' />
            <NavBar />
            <div
                className='content'
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '30px',
                }}
            >
                <ComboBox
                    dataId='partNameForm'
                    label='Part number'
                    defaultValue={partName}
                    suggestions={partNames ?? []}
                    onSubmit={setPartName}
                />
                {partName &&
                    <ProductInfoForm
                        partName={partName}
                        productInfo={productInfo}
                        readOnly={readOnly}
                    />
                }
            </div>
        </>
    );
}
